import { render, staticRenderFns } from "./CSPLucaBordroBranch.vue?vue&type=template&id=2b331d80&"
import script from "./CSPLucaBordroBranch.vue?vue&type=script&lang=js&"
export * from "./CSPLucaBordroBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports